module.exports = __webpack_public_path__ + "imgs/BipoCann.dee7e7c57064eaacbeb2cec89843edd3.png";